module.exports = __webpack_public_path__ + "static/img/hot-room.5cb79fe3.png";